import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of, switchMap } from 'rxjs';
import { MessageDialogComponent } from '../component/message-dialog.component';
import { CanDeactivateComponent } from '../interface/can-deactivate.interface';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class CanDeactivateGuard implements CanDeactivate<CanDeactivateComponent> {

    constructor(private dialog: MatDialog,
        private translate: TranslateService,
    ) { }

    canDeactivate(component: CanDeactivateComponent): Observable<boolean> | boolean {
        // console.log(component);
        if (component.canDeactivate()) {
            return true;
        }

        const dialogRef = this.dialog.open(MessageDialogComponent, {
            width: '400px',
            data: {
                message: this.translate.instant('MESSAGES.CAN_DIACTIVATE'),
                cancelTitle: this.translate.instant('BUTTON.NO'),
                okTitle: this.translate.instant('BUTTON.YES'),
                onOk: () => dialogRef.close(true),
                onCancel: () => dialogRef.close(false),
            }
        });
        // ダイアログを閉じた後の処理
        return dialogRef.afterClosed().pipe(
            // ダイアログが閉じられた後に遷移するかどうかを判断
            switchMap(result => {
                // console.log(result)
                if (result) {
                    return of(true);  // 遷移を許可
                } else {
                    return of(false); // 遷移をキャンセル
                }
            })
        );

    }
}
